import axios from "axios";


// Create an axios instance with the default headers
const api = axios.create({
  // baseURL: "http://192.168.29.103/projects/schoolErp/",

  // baseURL:"https://erp.sarvajna.co.in/api/"

  // baseURL:"https://sarvajna.onezo.in/api/"
  // baseURL:"https://api.sarvajna.co.in/erp/"

  baseURL:"https://edu.onezo.in/erp/"



  // baseURL:"https://api.sarvajna.co.in/owner/token/tokenCurl"


});

// Add the Authorization header to each request
api.interceptors.request.use(
  (config) => {
    const token = "kasejfksjdhfywterjwefbdskgfhsdfjh"; // Get the token from localStorage
  
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`; // Set the token in the Authorization header
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
